export type ComparisonGear={id:string;name:string;slot:string;atk:number;hp:number;def:number};
/** Select the previous item by the candidate's slot; never compare unrelated equipped slots. */
export function compareEquippedGear(catalog:readonly ComparisonGear[],candidateId:string,equipped:Readonly<Record<string,string>>){
 const candidate=catalog.find(g=>g.id===candidateId);if(!candidate)return null;
 const current=catalog.find(g=>g.id===equipped[candidate.slot]&&g.slot===candidate.slot);
 return {candidate,current,delta:{atk:candidate.atk-(current?.atk??0),hp:candidate.hp-(current?.hp??0),def:candidate.def-(current?.def??0)}};
}
